import React from "react";

const STATS = [
  { value: "15+", label: "Client Integrations" },
  { value: "90K+", label: "Products Managed" },
  { value: "99.9%", label: "Uptime SLA" },
  { value: "8+", label: "Microservices" },
  { value: "2K+", label: "Daily Orders" },
  { value: "30%", label: "API Speed Boost" },
  { value: "10K+", label: "Traders Served" },
  { value: "500+", label: "Vet Clinics" },
];

const StatsRow = ({ reverse }) => (
  <div className={`stats-track ${reverse ? "stats-reverse" : ""}`}>
    {[...STATS, ...STATS].map((stat, i) => (
      <span key={i} className="stats-item">
        <span className="stats-value">{stat.value}</span>
        <span className="stats-label">{stat.label}</span>
        <span className="stats-dot" />
      </span>
    ))}
  </div>
);

const StatsBanner = () => (
  <div className="stats-banner">
    <StatsRow />
    <StatsRow reverse />
  </div>
);

export default StatsBanner;
